export type NowWindowCap = {
  cappedByClose: boolean;
  cappedByDaylight?: boolean;
};

export function nowWindowLimitLabel(context: NowWindowCap): string | null {
  if (context.cappedByDaylight) return "trimmed to daylight";
  if (context.cappedByClose) return "trimmed to lift close";
  return null;
}

export function nowTooLateMessage(pedalOnly: boolean): string {
  return pedalOnly
    ? "There is not enough daylight left for a useful ride. Plan tomorrow instead?"
    : "The lifts are winding down for today. Plan tomorrow morning instead?";
}
